<template>
  <div id="login">
    <div class="login_box" v-bind:style="{ 'background-image': 'url(' + backgroundImage + ')' }">
      <div class="login_cont" style="height:530px;">
        <div class="login_contRight right">
          <!--<div class="login_header">
            <p class="login_back" @click="goLogin">登录</p>
            <p class="register_back login_active">注册</p>
          </div>
          &lt;!&ndash; 注册 &ndash;&gt;
          <div class="login_footer register">
            <p style="margin-top: 30px;">
              <span>手机号</span>
              <input
                type="tel"
                maxlength="11"
                class="r_input1"
                style="width: 287px;"
                placeholder="请输入手机号"
                v-model="reName"
              >
            </p>
            <p>
              <span>登录密码</span>
              <input
                type="password"
                class="r_input2"
                placeholder="请输入登录密码"
                style="width: 287px;"
                v-model="rePass"
              >
            </p>
            <p>
              <span>图形验证码</span>
              <input
                type="text"
                placeholder="请输入图片验证码"
                style="width: 194px;"
                class="r_input3"
                v-model="rePicCode"
              >
              <s-identify
                class="login_img"
                :identifyCode="identifyCode"
                :contentWidth="95"
                :contentHeight="42"
                @refreshcode="getRePicCode"
              ></s-identify>
            </p>
            <p>
              <span>短信验证码</span>
              <input
                type="text"
                class="r_input4"
                placeholder="请输入短信验证码"
                style="width: 194px;"
                v-model="rePhoneCode"
              >
              <button
                v-bind:disabled="disabled"
                class="login_code"
                @click="getPhoneCode"
              >{{phoneCodeText}}</button>
            </p>
            <p>
              <span>推荐码(选填)</span>
              <input
                type="text"
                class="r_input5"
                v-model="rePhone"
                placeholder="请输入推荐码(选填)"
                style="width: 287px;"
              >
            </p>
            <div class="login_agree">
              <input type="checkbox" v-model="reAgree" >
              <span>我同意</span>
              <router-link :to="{name:'Protocol',params:{type:1}}">《注册协议》</router-link>
&lt;!&ndash;              <router-link :to="{name:'Protocol',params:{type:3}}">《合格投资人申明》</router-link>&ndash;&gt;
              <router-link style="margin-left: 10px;margin-top: 10px;" :to="{name:'Protocol',params:{type:2}}">《风险揭示书》</router-link>

            </div>
            <button class="register_btn" @click="register">立即注册</button>
          </div>-->
          <el-card class="box-card" style="height: 100%">
            <!-- <div slot="header" class="clearfix">
              <span style="color: #E6A23C;display:none;">新用户注册</span>
              <div>
                <p style="text-align:center;font-size: 19px;color:red"><span>新会员最高专享礼</span></p><br>
                             <p style="text-align:center">~最高可领~</p>
                <p style="text-align:center">注册送<span style="color:red">{{sys_give_voucher_amount}}元</span></p>
                <p style="padding-top: 22px;color:red;text-align:center">豪礼一：新用户注册送{{sys_give_voucher_amount}}元</p>
                             <p style="text-align:center">注册<span style="color:red">&nbsp;<b>{{sys_give_voucher_amount}}</b>&nbsp;元</span>&nbsp;+&nbsp;首充礼品<span style="color:red">&nbsp;<b>10000</b>&nbsp;元</span>&nbsp;+&nbsp;交易红包<span style="color:red">&nbsp;<b>9999</b>&nbsp;元</span></p>
                              <p style="padding-top: 22px;color:red;text-align:center">豪礼一：新用户注册送&nbsp;<b>{{sys_give_voucher_amount}}</b>&nbsp;元</p>
              </div>
            </div> -->
            <div slot="header" class="clearfix">
              <span style="color: var(--baseColor)">{{ $t('registerPc.userRegister') }}</span>
            </div>
            <div class="content">
              <el-form ref="form" id="registerForm" >
                <!-- <el-form-item>
                  <el-input maxlength="11" v-model.number="reName" :placeholder="$t('registerPc.pleaseEnterPhoneNumber')"></el-input>
                </el-form-item> -->
                <el-form-item>
                  <el-input v-model="reName" :placeholder="$t('registerPc.pleaseEnterUsername')"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input show-password v-model="rePass" :placeholder="$t('registerPc.pleaseEnterPassword')"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="rePhone" :disabled="rePhone != null && rePhone != '' && codeFound" :placeholder="$t('registerPc.pleaseEnterReferralCode')"></el-input>
                </el-form-item>
                <el-form-item>
          <el-input :placeholder="$t('rechargeau.enterYourPhoneNumber')" v-model="setPhone.phone"></el-input>
        </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="rePicCodePopup" :placeholder="$t('registerPc.pleaseEnterGraphicCode')"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <img :src="captcha2" class="login_img" height="150" width="40" @click="this.getCaptcha2">
                      
                    </el-col>
                  </el-row>
                </el-form-item> 
              <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="rePhoneCode" :placeholder="$t('registerPc.pleaseEnterSmsVerificationCode')"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <el-button type="primary" @click="register" :disabled="disabled" style="width: 100%; background-color: var(--baseColor);">{{getCodeText}}</el-button>
                    </el-col>
                  </el-row>
                </el-form-item> 
                <el-form-item style="margin: 0">
                  <el-checkbox v-model="reAgree">{{$t('registerPc.agree')}}</el-checkbox><router-link :to="{name:'Protocol',params:{type:1}}">{{$t('registerPc.registerAgreement')}}</router-link><router-link :to="{name:'Protocol',params:{type:2}}">{{ $t('registerPc.riskDisclosureStatement') }}</router-link>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="width: 100%;background-color: var(--baseColor);border-color:var(--baseColor)" @click="confirmRegister">{{$t('registerPc.createNow')}}</el-button>
                </el-form-item>
       
              </el-form>
            </div>

          </el-card>
        </div>
      </div>
    </div>
    <!--<div class="login_box">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>卡片名称</span>
          <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>
        </div>
        <div v-for="o in 4" :key="o" class="text item">
          {{'列表内容 ' + o }}
        </div>
      </el-card>
    </div>-->
    <el-dialog id="registerSuccessPopup" :visible.sync="isRegisterSuccess">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <p style="text-align:center; font-size: 17px">{{ $t('registerPc.registerSuccess') }}</p>
          <p style="text-align:center; font-size: 17px;margin-top:15px;">{{$t('registerPc.loginToClaim')}}<span>&nbsp;{{sys_give_voucher_amount}}&nbsp;</span>{{$t('registerPc.giftMoney')}}</p>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="cancel()">{{$t('registerPc.cancel')}}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="login()">{{$t('registerPc.loginImmediately')}}</el-button>
      </div>
    </el-dialog>

     <!-- Set phone number popup -->
     <el-dialog :title="$t('rechargeau.setPhone')" :visible.sync="isShowPhone" width="25%"
      :close-on-click-modal="false" @close="isShowPhoneClose">
      <el-form>
        <el-form-item>
          <el-input :placeholder="$t('rechargeau.enterYourPhoneNumber')" v-model="setPhone.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="14">
              <el-input v-model="rePicCodePopup" :placeholder="$t('registerPc.pleaseEnterGraphicCode')"></el-input>
            </el-col>
            <el-col :span="10">
              <img :src="captcha2" class="login_img" height="150" width="40" @click="this.getCaptcha2">
              
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="14">
              <el-input v-model="setPhone.otp" :placeholder="$t('registerPc.pleaseEnterSmsVerificationCode')"></el-input>
            </el-col>
            <el-col :span="10">
              <el-button type="primary" @click="getPhoneCodeNumber" :disabled="disabled" style="width: 100%; background-color: var(--baseColor);">{{getCodeText}}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowPhoneClose()">{{
          $t("rechargeau.cancel")
        }}</el-button>
        <el-button
          type="primary"
          style="background-color: var(--baseColor);border-color:var(--baseColor)"
          @click="confirmRegister"
          >{{ $t("rechargeau.sure") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>

import $ from "jquery";
import SIdentify from "../components/icode";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import eventBus from "../assets/js/eventBus";
import { version,description } from "../../package.json";
import axios from "axios";
export default {
  name: "Register",
  components: {
    SIdentify
  },
  data() {
    return {
      reName: "", //注册_账号
      rePass: "", //注册_密码
      rePicCode: "", //注册_图形验证码
      rePicCodePopup: "", //注册_图形验证码
      identifyCode: "", //注册_图形验证码图片
      identifyCodes: "123456789",
      rePhoneCode: "", //注册_短信验证码
      rePhone: "", //注册_邀请人手机号
      reAgree: true, //注册_注册协议 false：不同意 true：同意
      phoneCodeText: this.$t('registerPc.getVerificationCode'),
      disabled: false,
      isRegisterSuccess: false,
      sys_give_voucher_amount: "",
      captcha: '',
      verify_token: '',
      captcha2: '',
      verify_token2: '',
      codeFound: false,
      isShowPhone: false,
      setPhone: {
        phone: '',
        otp: ''
      },
      disabled: false,
      timer1: {},
      phoneCodeText: this.$t('registerPc.getVerificationCode'),
      getCodeText: this.$t('information.getVerificationCode'),
      backgroundImage: '',
      clientIp:'',
    };
  },
  created() {
    // this.getCaptcha();
  },
  mounted: function () {
    localStorage.setItem("chatUpdated", false);
    localStorage.setItem("systemMessages", "");
    localStorage.setItem("systemUnread", 0);
    eventBus.$emit('updateTotalCount');
    eventBus.$emit("endChat");
    this.getRefCode()
    this.getClientIp();
    //     const urlParams = new URLSearchParams(window.location.search);
    // const myParam = urlParams.get('code');
    //     console.log("myParam",myParam)
    //     var foo = getParameterByName('code');
    //     console.log("efgrerg",foo)
    // console.log("rtgreger",this.$router.history.current.query.code)
    this.rePhone = localStorage.getItem('reCouponCode');
    this.rePhone = this.$router.history.current.query.code;



    this.realNameConfig();
    //获取图片验证码
    // this.getRePicCode();
    this.get_rePhone();
    if(window.sessionStorage.getItem("rePhone")){
      this.codeFound = true;
    }else{
      this.codeFound = false;
    }
    this.getCaptcha2();
    this.getBackgroundImage();
    // $("#wrapper").css("background", "#737373");
    /*$("body,html").css({ overflow: "inherit", height: "100%" });
    var canvas = document.getElementById("canvas");
    // var ctx = canvas.getContext("2d");
    // var w = (canvas.width = window.innerWidth);
    // var h = (canvas.height = window.innerHeight);
    var hue = 217;
    var stars = [];
    var count = 0;
    var maxStars = 500;
    var canvas2 = document.createElement("canvas");
    var ctx2 = canvas2.getContext("2d");
    canvas2.width = 100;
    canvas2.height = 100;
    var half = canvas2.width / 2;
    var gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half);
    gradient2.addColorStop(0.025, "#eee");
    gradient2.addColorStop(0.1, "hsl(" + hue + ", 61%, 33%)");
    gradient2.addColorStop(0.25, "hsl(" + hue + ", 64%, 6%)");
    gradient2.addColorStop(1, "transparent");
    ctx2.fillStyle = gradient2;
    ctx2.beginPath();
    ctx2.arc(half, half, half, 0, Math.PI * 2);
    ctx2.fill();*/

    /*function random(b, a) {
      if (arguments.length < 2) {
        a = b;
        b = 0;
      }
      if (b > a) {
        var c = a;
        a = b;
        b = c;
      }
      return Math.floor(Math.random() * (a - b + 1)) + b;
    }

    function maxOrbit(b, d) {
      var a = Math.max(b, d),
        c = Math.round(Math.sqrt(a * a + a * a));
      return c / 2;
    }
    var Star = function() {
      this.orbitRadius = random(maxOrbit(w, h));
      this.radius = random(60, this.orbitRadius) / 8;
      this.orbitX = w / 2;
      this.orbitY = h / 2;
      this.timePassed = random(0, maxStars);
      this.speed = random(this.orbitRadius) / 80000;
      this.alpha = random(2, 10) / 10;
      count++;
      stars[count] = this;
    };
    Star.prototype.draw = function() {
      var a = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
        c = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
        b = random(10);
      if (b === 1 && this.alpha > 0) {
        this.alpha -= 0.05;
      } else {
        if (b === 2 && this.alpha < 1) {
          this.alpha += 0.05;
        }
      }
      ctx.globalAlpha = this.alpha;
      ctx.drawImage(
        canvas2,
        a - this.radius / 2,
        c - this.radius / 2,
        this.radius,
        this.radius
      );
      this.timePassed += this.speed;
    };
    for (var i = 0; i < maxStars; i++) {
      new Star();
    }

    function animation() {
      ctx.globalCompositeOperation = "source-over";
      ctx.globalAlpha = 0.5;
      ctx.fillStyle = "#023164";
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = "lighter";
      for (var b = 1, a = stars.length; b < a; b++) {
        stars[b].draw();
      }
      window.requestAnimationFrame(animation);
    }
    animation();*/
  },
  methods: {
    getBackgroundImage() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "pc_register_background_image",
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.backgroundImage = res.data.data.replace(/ /g, "%20");
          }
        });
    },
    isShowPhoneClose(){
      let that = this;
      that.isShowPhone = false;
      that.rePicCodePopup= "";
      that.setPhone.otp= "";
      that.rePicCode = "";
      that.getCaptcha2();
      that.getCaptcha();
      clearInterval(that.timer1);
      that.disabled = false;
      that.getCodeText = that.$t('information.getVerificationCode');
    },
    getPhoneCodeNumber() {
      let that = this;
      const publicKey = localStorage.getItem('encript_public_key')
      const registerPhoneEncrypted = that.encryptMessage(that.setPhone.phone.toString(), publicKey)
      clearInterval(that.timer1);
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.setPhone.phone)) {
        that.$message.error(this.$t('information.phoneFormatIncorrect'));
      } else {
        that
          .$http({
            url: "/app/SendSms/register_code_e",
            method: "post",
            data: {
              phone: registerPhoneEncrypted,
              rePicCode: parseInt(that.rePicCodePopup),
              verifyToken: that.verify_token2
            }
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success",
                duration: 2000
              });
              var time = 60;
              that.disabled = true;
              that.getCodeText = time + "s";
              that.timer1 = setInterval(function () {
                time--;
                that.getCodeText = time + "s";
                if (time <= 0) {
                  clearInterval(that.timer1);
                  that.disabled = false;
                  that.getCodeText = that.$t('information.getVerificationCode');
                  that.rePicCodePopup= "";
                  that.getCaptcha2();
                }
              }, 1000);
            } else {
              that.$message.error(that.$t(res.data.msgId));
              that.rePicCodePopup= "";
              that.getCaptcha2();
            }
          });
      }
    },
    usernameverify() {
      let that = this;
      that
        .$http({
          url: "/app/User/user_validate",
          method: "post",
          data: {
            user_name: that.reName,
            reid: that.rePhone,
            // captcha: parseInt(that.rePicCode),
            verifyToken: that.verify_token

          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            // that.rePicCodePopup= "";
            // that.getCaptcha2();
            that.getPhoneCodeNumber();
          } else {
            that.$message.error(that.$t(res.data.msgId));
            // that.rePicCode= "";
            // that.getCaptcha();

          }
        });
    },
    getRefCode() {
      const currentUrl = window.location.href;
      if (currentUrl.includes('?code=')) {
        const withoutDomain = currentUrl.split("?code=")[1];
        const refcode = withoutDomain.split("#/login")[0];
        window.sessionStorage.setItem("rePhone", refcode);
      }
    },
    realNameConfig() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "sys_give_voucher_amount"
          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            //first time Recharge
            that.sys_give_voucher_amount = res.data.data;
            // that.isFirstTimeTrading = false;
            // localStorage.setItem("isFirstTimeRecharge", false);
          } else {
            // that.isFirstTimeTrading = true;
            // localStorage.setItem("isFirstTimeRecharge", true);

          }
        });
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    getCaptcha() {
      let that = this;
      that.$http({
        url: "/app/SendSms/getSmsPic",
        method: "post",
        data: {

        },
      })
        .then(function (res) {
          let resData = res.data;
          if (resData.status == 200) {

            that.captcha = "data:image/png;base64," + resData.data.data.img;

            that.verify_token = resData.data.data.key;
          } else {
            that.disabled = false;
            that.$message.error(that.$t(res.data.msgId));
          }
        });
      // this.captcha = 'https://server.hk9999z.com/captcha?v='+Math.random();
    },
    getCaptcha2() {
      let that = this;
      that.$http({
        url: "/app/SendSms/getSmsPic",
        method: "post",
        data: {

        },
      })
        .then(function (res) {
          let resData = res.data;
          if (resData.status == 200) {

            that.captcha2 = "data:image/png;base64," + resData.data.data.img;

            that.verify_token2 = resData.data.data.key;
          } else {
            that.disabled = false;
            that.$message.error(that.$t(res.data.msgId));
          }
        });
      // this.captcha = 'https://server.hk9999z.com/captcha?v='+Math.random();
    },
    getPhoneCode() {
      let that = this;
      // if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.reName)) {
      //   that.$message.error(this.$t('registerPc.phoneFormatIncorrect'));
      // } else {

        const publicKey = localStorage.getItem('encript_public_key')

        const registerPhoneEncrypted = that.encryptMessage(that.reName.toString(), publicKey)

        that.disabled = true;
        that.$http({
          url: "/app/SendSms/register_code_e",
          method: "post",
          data: {
            phone: registerPhoneEncrypted,
            rePicCode: that.rePicCodePopup,
            verifyToken: that.verify_token2
          },
        })
          .then(function (res) {
            if (res.data.status == 200) {
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success"
              });
              var time = 60;
              that.phoneCodeText = time + "s";
              var timer1 = setInterval(function () {
                
                if (time > 0) {
                  time--;
                  that.phoneCodeText = time + "s";
                 
                }else{
                  that.rePicCodePopup= "";
                  that.getCaptcha2();
                  that.phoneCodeText = that.$t('registerPc.getVerificationCode');
                  that.disabled = false;
                  clearInterval(timer1);
                }
              }, 1000);
            } else {
              that.disabled = false;
              that.$message.error(that.$t(res.data.msgId));
              that.rePicCodePopup= "";
              that.getCaptcha2();
              that.phoneCodeText = that.$t('registerPc.getVerificationCode');
            }
          });
      // }
    },
    setPhoneNum(){
      let that = this;
      that
        .$http({
          url: "/app/User/popupPhone",
          method: "post",
          data: {
            phoneNumber: that.setPhone.phone,
            code: that.setPhone.otp,
            userName: that.reName
          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.$message.success(that.$t(res.data.msgId));
            that.isShowPhone = false;
            // that.getConfig();

            that.confirmRegister();
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    stringWhitespaceValidation(str) {
      return /^[A-Za-z0-9_\u4e00-\u9fa5]+$/.test(str);
    },
    goLogin() {
      this.$router.push({
        path: "/login"
      });
    },
    //获取注册 图片验证码
    getRePicCode() {
      // this.rePicCode = "";
      // this.identifyCode = "";
      // this.makeCode(this.identifyCodes, 4);
    },
    // 生成一个随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //更新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //创建图形验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    register() {
      let that = this;
      // if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.reName)) {
      //   that.$message.error(this.$t('registerPc.phoneFormatIncorrect'));
      // } else 
      if (!that.stringWhitespaceValidation(that.reName)) {
        that.$message.error(this.$t('registerPc.whiteSpaceErrorMessage'));
			} else if (that.reName == "") {
        that.$message.error(this.$t('registerPc.pleaseEnterUsername'));
      } else if (that.rePass == "") {
        that.$message.error(this.$t('registerPc.pleaseEnterPassword'));
      } else if (that.reAgree == false) {
        that.$message.error(this.$t('registerPc.agreeRegistrationAgreement'));
      } else if (that.rePhone == false) {
        that.$message.error(this.$t('registerPc.pleaseEnterReferralCode'));
      } else {

        // const publicKey = localStorage.getItem('encript_public_key')

        // const registerUnameEncrypted = that.encryptMessage(that.reName.toString(), publicKey)
        // const passwordEncrypted = that.encryptMessage(that.rePass.toString(), publicKey)

        that.usernameverify();
        
      }
    },
    getClientIp() {
      let context = this;
      axios
        .get('https://ifconfig.me/all.json')
        .then((response) => {
          context.clientIp = response.data.ip_addr;
          console.log("IP", this.clientIp)
          // context.updateUserIp(clientIp);
        })
        .catch(() => {
          console.log('Primary IP fetch failed');
          context.getConfigIPUrl().then((configString) => {
            if (configString) {
              let parts = configString.split(',');
              let url = parts[0].trim();
              let field = parts[1].trim();

              axios
                .get(url)
                .then((response) => {
                  context.clientIp = response.data[field]; 
                  console.log('Config URL IP', context.clientIp);
                  // context.updateUserIp(clientIp);
                })
                .catch(() => {
                  console.error('Config URL IP fetch failed.');
                });
            } else {
              console.error('Config URL IP config not in expected format (url,field)');
            }
          });
        });
    },
    getConfigIPUrl() {
      return this.$http({
        url: "/app/Sysconfig/sysconfig/name",
        method: "post",
        data: {
          name: "login_ip_get_gateway"
        }
      }).then(function (res) {
        if (res.data.status === 200) {
          console.log('res',res.data.data)
          return res.data.data; 
        } else {
          return null;
        }
      }).catch(function () {
        return null;
      });
    },
    // updateUserIp(ip) {
    //   let context = this;
    //   context.http({
    //     url: 'app/User/update_ip',
    //     method: 'post',
    //     data: {
    //       type: 0,
    //       clientIp: ip
    //     },
    //   }).then(res => {
    //     console.log("IP Updated.");
    //   })
    // },
    confirmRegister() {
      let that = this;

      const publicKey = localStorage.getItem('encript_public_key')
      const registerPhoneEncrypted = that.encryptMessage(that.setPhone.phone.toString(), publicKey);
      const registerPassEncrypted = that.encryptMessage(that.rePass.toString(), publicKey)


      that
        .$http({
          url: "/app/User/register_new_e",
          method: "post",
          data: {
            user_name: that.reName,
            password: registerPassEncrypted,
            reid: that.rePhone,
            phone: registerPhoneEncrypted,
            smsCode: that.rePhoneCode,
            app_version: version.version,
            ip:that.clientIp
          }
        })
        .then(function(res) {
          if (res.data.status == 200) {
            // that.realNameConfig();
            that.isRegisterSuccess = true; 
            // that.loginRegister(that.reName, that.rePass, ip);
          } else {
            that.rePicCodePopup = "";
            that.rePicCode = "";
            that.setPhone.phone = "";
            that.setPhone.otp = "";
            // that.getCaptcha();
            that.rePhoneCode="";
            that.getCaptcha2();
            // that.isShowPhone = false;
            clearInterval(that.timer1);
            that.disabled = false;
            that.getCodeText = that.$t("information.getVerificationCode");
            that.$message.error(that.$t(res.data.msgId));
          }

        });
    },
    loginRegister(username, password) {
      let that = this;
      that
        .$http({
          url: "/app/User/registerLogin",
          method: "post",
          data: {
            user_name: username,
            password: password,
            app_version: version.version,
            build_number: description
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            localStorage.setItem('isSimulation',false)
            that.$message({
              message: that.$t(res.data.msgId),
              type: "success",
              duration: 1000
            });
            window.sessionStorage.setItem("loginType", true);
            let user_number = res.data.data.user_number;
            localStorage.setItem("user_number", user_number);
            localStorage.setItem("password", password);
            that.$store.commit("changeLoginType", true);
            eventBus.$emit("startChat")
            that.getAgentList()
            // that.loginService();

            that.$router.push({
              path: "/myaccount"
            });
            window.sessionStorage.setItem("token", res.data.data.token);
            // if (that.loginRememeber == true) {
            //   window.localStorage.setItem("name", username);
            //   window.localStorage.setItem("rememberName", true);
            // } else {
            //   localStorage.removeItem("name");
            //   localStorage.removeItem("rememberName");
            // }
            localStorage.removeItem("name");
            localStorage.removeItem("rememberName");
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    get_rePhone() {
      let that = this;
      let code = this.$route.query.code;
      let rePhone = window.sessionStorage.getItem("rePhone");

      if (!code && !rePhone) {

        that.rePhone = '';


        // that.rePhone = code;
      } else {
        if (!code == false) {
          that.rePhone = code;
          window.sessionStorage.setItem("rePhone", code);
        } else if (!rePhone == false) {
          that.rePhone = rePhone;
          window.sessionStorage.setItem("rePhone", rePhone);
        }
      }
    },
    cancel() {
      this.isRegisterSuccess = false;
    },
    login() {
      this.$router.push({
        name: "Login"
      })
    },
    getAgentList() {
      let that = this;
      that
        .$http({
          url: "/app/Chat/agentList",
          method: "post",
          data: {},
          chatUrl: true,
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            const chatList = res.data.data;
            chatList.forEach(element => {
              element.messages = [];
            })
            localStorage.setItem("agent_list", JSON.stringify(chatList))
            if (chatList.length > 0) {
              that.getChatHistory()
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    getChatHistory() {
      let that = this;
      that
        .$http({
          url: "/app/Chat/getHistory",
          method: "post",
          data: {
            user_id: localStorage.getItem("uid")
          },
          chatUrl: true,
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            let msgList = res.data.data;
            msgList = msgList.filter(element => element.is_read == 1);

            msgList.sort((a, b) => b.timestamp - a.timestamp);

            const systemMessages = msgList.filter(element => element.sender === "SYSTEM")
            that.handleSystemMessage(systemMessages)
            
            const setMessagePromises = msgList.map(element => that.setMessageList(element));

            Promise.all(setMessagePromises).then(res => {
              const msgListReversed = msgList.reverse();

              // Set the count
							const messageAgents = JSON.parse(localStorage.getItem('agent_list'));
              const uid = localStorage.getItem('uid');
							messageAgents.forEach(element => {
                const unreadMsgs = element.messages.filter(item => item.is_read != 1 && item.receiver == uid && item.type != -100);
                element.count = unreadMsgs.length;
              });
              localStorage.setItem("agent_list", JSON.stringify(messageAgents));
							eventBus.$emit("updateTotalCount");

              if (msgListReversed.length) {
                const uid = localStorage.getItem("uid")

                msgListReversed.every(item => {
                  if (item.is_read == 1 && item.receiver != 'SYSTEM') {
                    localStorage.setItem('last_msg_id', item.order_id);
                    localStorage.setItem('last_msg_receiver', item.receiver);
                    return false;
                  } else {
                    localStorage.setItem('last_msg_id', '');
                    localStorage.setItem('last_msg_receiver', '');
                    return true;
                  }
                })
              } else {
                localStorage.setItem('last_msg_id', '');
                localStorage.setItem('last_msg_receiver', '');
              }
              localStorage.setItem("chatUpdated", true);
            })
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    setMessageList(messageItem) {
      return new Promise((resolve, reject) => {
        let agentList = JSON.parse(localStorage.getItem('agent_list'));
        agentList.forEach((element, index) => {
          if (element.number == messageItem.receiver || element.number == messageItem.sender) {
            element.messages.push(messageItem);
            element.last_msg = messageItem;
          }
          // Resolve at the last message
          if (index === agentList.length - 1) {
            localStorage.setItem("agent_list", JSON.stringify(agentList));
            resolve();
          }
        });

        // If list is empty
        if (agentList.length === 0) {
          localStorage.setItem("agent_list", JSON.stringify(agentList));
          resolve();
        }
      })
    },
    handleSystemMessage(systemMessages) {
      if (systemMessages) {
        systemMessages.forEach((message) => {
          const availableMessages = localStorage.getItem("systemMessages") ? JSON.parse(localStorage.getItem("systemMessages")) : [];
          const messageAvailable = availableMessages.length ? availableMessages.find(element => element.order_id == message.order_id) : false;

          if (!messageAvailable) {
            availableMessages.push(message)
            localStorage.setItem("systemMessages", JSON.stringify(availableMessages))

            // eventBus.$emit("onChatReceived", message);
          }
        })
      }
    }
  }
};
</script>
<style scoped>
@import url("./../assets/css/login.css");
.picCode {
  display: inline-block;
  width: 97px;
  height: 41px;
  position: absolute;
  right: 78px;
  top: 253px;
}
.content{
  width: 80%;
  margin: 0 auto;
  /*text-align: center;*/
}

.space {
  margin-top: 68px;
}

</style>
<style>
#registerForm .el-form-item{
  margin-bottom: 11px;
}
#registerSuccessPopup .el-dialog__body {
  padding: 0px;
}
#registerSuccessPopup .el-form-item__content {
  margin-left: 0px !important;
}
#registerSuccessPopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/register.vue